import React from 'react';
import { Search, Bell, Menu } from 'lucide-react';

const AccountNavbar = ({ userData, onMenuClick }: { userData: any, onMenuClick: () => void }) => {
  return (
    <header className="h-20 bg-[#0b1221] border-b border-gray-800 flex items-center justify-between px-4 md:px-8 shrink-0">
      
      {/* Mobile Menu & Greeting */}
      <div className="flex items-center gap-4">
        <button onClick={onMenuClick} className="md:hidden text-gray-400 hover:text-white">
          <Menu size={24} />
        </button>
        <div className="md:hidden flex items-center gap-2">
          <div className="w-10 h-10 bg-[#131b2c] rounded-full flex items-center justify-center text-blue-500 font-bold border border-gray-700">
            {userData?.first_name?.charAt(0)}{userData?.last_name?.charAt(0)}
          </div>
          <div>
            <p className="text-xs text-gray-400 leading-tight">Hello,</p>
            <p className="text-sm font-bold text-white leading-tight">{userData?.first_name}</p>
          </div>
        </div>
      </div>

      {/* Desktop Search */}
      <div className="hidden md:flex items-center bg-[#131b2c] rounded-full px-4 py-2.5 w-96 border border-gray-700 focus-within:border-blue-500 transition-colors">
        <Search size={18} className="text-gray-500 mr-2" />
        <input type="text" placeholder="Search stocks, transactions..." className="bg-transparent border-none outline-none text-sm w-full text-white" />
      </div>
      
      {/* Right Actions */}
      <div className="flex items-center gap-4 md:gap-6">
        <button className="relative text-gray-400 hover:text-white transition-colors">
          <Bell size={22} />
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-[#0b1221]"></span>
        </button>
        
        {/* Desktop Profile Info */}
        <div className="hidden md:flex items-center gap-3 pl-6 border-l border-gray-800">
          <div className="text-right">
            <p className="text-sm font-bold text-white">{userData?.first_name} {userData?.last_name}</p>
            <p className="text-xs text-gray-500 uppercase">{userData?.login_id}</p>
          </div>
          <div className="w-10 h-10 bg-[#131b2c] rounded-full flex items-center justify-center text-blue-500 font-bold border border-gray-700 shadow-inner">
            {userData?.first_name?.charAt(0)}{userData?.last_name?.charAt(0)}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AccountNavbar;